import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICommodity, ICommodityState } from "./commodityModel";
import {
  commodityActiveInactive,
  createCommodity,
  deleteCommodity,
  getAllActiveCommodity,
  getAllCommodity,
  getCommodityByID,
  updateCommodity,
} from "./services/commodity.service";

const initialState: ICommodityState = {
  loading: false,
  formLoading: false,
  error: "",
  CommodityList: [],
  CommodityID: null,
  CommodityDetail: {
    name: "",
    description: "",
    isactive: 1,
  },
};

const commoditySlice = createSlice({
  name: "commodity",
  initialState,
  reducers: {
    clearCommodityDetails: (state) => {
      state.CommodityDetail = initialState.CommodityDetail;
    },
    setCommodityID: (state, action) => {
      state.CommodityID = action.payload;
    },
    clearCommodityID: (state) => {
      state.CommodityID = initialState.CommodityID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllCommodity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllCommodity.fulfilled,
      (state, action: PayloadAction<ICommodity[]>) => {
        state.loading = false;
        state.CommodityList = action.payload || [];
      }
    );
    builder.addCase(getAllCommodity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CommodityList = [];
    });
    builder.addCase(getAllActiveCommodity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveCommodity.fulfilled,
      (state, action: PayloadAction<ICommodity[]>) => {
        state.loading = false;
        state.CommodityList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveCommodity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CommodityList = [];
    });
    builder.addCase(createCommodity.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createCommodity.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createCommodity.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateCommodity.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateCommodity.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateCommodity.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteCommodity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCommodity.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCommodity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(commodityActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(commodityActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(commodityActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getCommodityByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getCommodityByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.CommodityDetail = action.payload;
    });
    builder.addCase(getCommodityByID.rejected, (state, action) => {
      state.formLoading = false;
      state.CommodityDetail = initialState.CommodityDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearCommodityDetails, setCommodityID, clearCommodityID } =
  commoditySlice.actions;
export default commoditySlice.reducer;
